module.exports = __webpack_public_path__ + "images/b40009117cc9d385a1380e1f71331afe.webp";